(function() {
  require(["pricelist/routers/AppRouter", "bootstrap-collapse", "bootstrap-tab", "commons/modulemap"], function(AppRouter) {
    var exports;
    exports = window.app = window.app || {};
    return exports.router = new AppRouter();
  });

}).call(this);

//# sourceMappingURL=app.js.map
;
define("Apps/Pricelist/script/app", function(){});

